import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import FloatingCTA from "./components/FloatingCTA";

import Forside from "./pages/Forside";
import Hovtrim from "./pages/Hovtrim";
import FAQPage from "./pages/FAQPage";
import OmMig from "./pages/OmMig";
import ISNHCPPage from "./pages/ISNHCPPage";
import Vandrefolde from "./pages/Vandrefolde";
import Priser from "./pages/Priser";
import KontaktPage from "./pages/KontaktPage";
import NotFound from "./pages/NotFound";
import Forbidden from "./pages/Forbidden";

export default function App() {
  return (
    <>
      <ScrollToTop />
      <FloatingCTA />
      <div className="flex flex-col min-h-screen bg-sand-50 text-charcoal-800 antialiased font-sans selection:bg-forest-800 selection:text-white">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Forside />} />
            <Route path="/hovtrim" element={<Hovtrim />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/om-mig" element={<OmMig />} />
            <Route path="/isnhcp" element={<ISNHCPPage />} />
            <Route path="/vandrefolde" element={<Vandrefolde />} />
            <Route path="/priser" element={<Priser />} />
            <Route path="/kontakt" element={<KontaktPage />} />
            <Route path="/403" element={<Forbidden />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </>
  );
}
